import React, {useState} from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Chart from "react-apexcharts";

const DataChart = ({error, axes, dataCases, dataDeaths, dataRecovered}) => {
    const [size] = useState([window.innerHeight, window.innerWidth]);

    const dataMaker = (axes, data) => {
        let dataToSend = [];
        // eslint-disable-next-line array-callback-return
        axes.map((val, index) => {
            let item = {
                x: val,
                y: data[index],
            };
            dataToSend.push(item);
        });
        return dataToSend;
    };

    return (
        <React.Fragment>
            {!error && size && (
                <Chart
                    series={[
                        {name: "Cases", data: dataMaker(axes, dataCases)},
                        {name: "Deaths", data: dataMaker(axes, dataDeaths)},
                        {name: "Recovered", data: dataMaker(axes, dataRecovered)},
                    ]}
                    options={{
                        stroke: {
                            width: 2,
                            curve: "straight",
                        },
                        colors: ["#fff", "#f44336", "#76ff03"],
                        tooltip: {
                            theme: "dark",
                        },
                        chart: {
                            stacked: false,
                            id: "line-chart",
                            toolbar: {
                                show: true,
                                offsetX: 0,
                                offsetY: 0,
                                tools: {
                                    download: false,
                                    selection: true,
                                    zoom: true,
                                    zoomin: true,
                                    zoomout: true,
                                    pan: true,
                                    reset:
                                        true |
                                        '<img src="/static/icons/reset.png" width="20">',
                                    customIcons: [],
                                },
                                autoSelected: "zoom",
                            },
                        },
                        dataLabels: {
                            enabled: false,
                        },
                        markers: {
                            size: 5,
                            strokeWidth: 3,
                            strokeColors: ["#fff", "#f44336", "#76ff03"],
                            colors: "#fff",
                        },
                        xaxis: {
                            type: "datetime",
                            categories: axes,
                            labels: {
                                style: {
                                    colors: "#ffffff",
                                    fontSize: "12px",
                                },
                            },
                        },
                        yaxis: {
                            labels: {
                                style: {
                                    colors: "#ffffff",
                                    fontSize: "12px",
                                },
                            },
                        },
                        legend: {
                            position: "top",
                            horizontalAlign: "left",
                            fontSize: "20px",
                            labels: {
                                useSeriesColors: true,
                            },
                            offsety: 10,
                        },
                        responsive: [
                            {
                                breakpoint: 600,
                                options: {
                                    stroke: {
                                        width: 1,
                                        curve: "straight",
                                    },
                                    markers: {
                                        size: 1.5,
                                    },
                                    chart: {
                                        id: "line-chart",
                                        toolbar: {
                                            show: false,
                                        },
                                    },
                                },
                            },
                        ],
                    }}
                    type="area"
                    width={size[1] - 100}
                    height={size[0] - 100}
                ></Chart>
            )}
            {error && (
                <Grid item md={3} xs={12}>
                    <Paper style={{padding: "10px"}}>
                        <Typography variant="h4" style={{color: "#fff"}}>
                            Error Ocurred. Refesh or try later.
                        </Typography>
                    </Paper>
                </Grid>
            )}
        </React.Fragment>
    );
};

export default DataChart;
